<template>
  <span
    :data-tooltip="tooltipText"
    class="has-tooltip-left"
    :style="tooltipStyle">
  </span>
</template>

<script>
export default {
  name: 'TooltipStatus',
  props: {
    complete: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    tooltipStyle () {
      let backgroundColor = 'gray'

      if (this.complete) {
        backgroundColor = 'green'
      } else {
        backgroundColor = 'orange'
      }

      return {
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        marginLeft: '5px',
        backgroundColor: backgroundColor
      }
    },
    tooltipText () {
      if (this.complete) {
        return 'Completado'
      } else {
        return 'Pendiente'
      }
    }
  }
}
</script>

<style scoped>
/* Aquí puedes agregar estilos adicionales si es necesario */
</style>
